import { useMemo } from 'react';
import { useQuery } from 'urql';

import { useGetLoggedInUser } from '@revelio/auth';
import { GET_USER_REPORTS, Tab } from '@revelio/data-access';

import { useLogQueryIsNotReady } from '../../../../src/shared/hooks/useLogQueryIsNotReady';

export const useUserBuiltReports = (userIds?: string[]) => {
  const { loggedInUser } = useGetLoggedInUser();
  const hasReports = loggedInUser?.tabs?.includes(Tab.Reports);
  const ids = useMemo(() => {
    if (userIds) {
      return userIds;
    }

    return loggedInUser?.id ? [loggedInUser.id] : [];
  }, [loggedInUser, userIds]);

  const isQueryReady = !!(hasReports && ids.length > 0);
  useLogQueryIsNotReady({
    isQueryReady: isQueryReady,
    queryName: 'GET_USER_REPORTS',
    additionalMetadata: { ids },
  });
  return useQuery({
    query: GET_USER_REPORTS,
    variables: { ids },
    pause: !isQueryReady,
    requestPolicy: 'network-only',
  });
};
